import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.6667 19.5L4 12.5M4 12.5L10.6667 5.5M4 12.5H20",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIcArrowLeft;
